import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Theme } from 'src/interfaces';

const initialState: Theme = {
    darkTheme: false,
};

export const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        changeTheme: (state: Theme, action: PayloadAction<boolean>) => { state.darkTheme = action.payload },
    },
});

export const { changeTheme } = themeSlice.actions;

export default themeSlice.reducer;